import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Button } from '@src/common/Button';
import { useTinRegistration } from '@src/state/tinRegistration';

export const DraftValidationModel = ({
  isOpen,
  closeModal,
  handleStartRegistration,
}) => {
  const { disableSaveAsDraft } = useTinRegistration.actions();
  const handleCloseModal = () => {
    disableSaveAsDraft(false);
    closeModal();
  };

  const handleContinue = () => {
    handleStartRegistration();
    closeModal();
  };

  const ModalTextBody = styled('div', {
    margin: '5px 0 12px',
    lineHeight: '1.2',
    overflowWrap: 'break-word',
  });

  return (
    <Modal
      id="draft-validation-modal"
      isOpen={isOpen}
      onClose={closeModal}
      title="Saved Registration Limit Reached"
      hideClose
      footer={
        <Modal.Section>
          <Layout.Group alignLayout="right">
            <Button onClick={handleContinue}>Yes</Button>
            <Button variant="outline" onClick={handleCloseModal}>
              No
            </Button>
          </Layout.Group>
        </Modal.Section>
      }
    >
      <Modal.Section>
        <ModalTextBody id="draft-validation-modal-modal">
          If you wish to continue, you will not be able to save additional
          sessions.
          <br />
        </ModalTextBody>
      </Modal.Section>
    </Modal>
  );
};

DraftValidationModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleStartRegistration: PropTypes.func.isRequired,
};
